<template>
  <div class="connect">
    <Header current="community" active="connect" @scroll="handleScroll"></Header>
    <div class="con">
      <h3>{{ $t('lang.connect.tit1') }}</h3>
      <p class="f12 mbtm52">{{ $t('lang.connect.text1') }}</p>
      <div class="icons">
        <div
          v-for="(item, index) in icons"
          :key="index"
          :class="item.icon"
          @click="gotoLink(item.link)"
        ></div>
      </div>
      <h3>{{ $t('lang.connect.tit2') }}</h3>
      <div class="swiper" @mouseover="enter" @mouseleave="leave">
        <swiper ref="mySwiper" :options="swiperOption" v-if="swiperData.length > 0">
          <swiper-slide class="swiper-slide" v-for="(item, index) in swiperData" :key="index">
            <div class="swiper-img" @click="gotoLink(item.url)">
              <img :src="item.img" />
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
    <div class="become" id="ambassador">
      <div class="con">
        <h3>{{ $t('lang.connect.tit3') }}</h3>
        <p class="f12">{{ $t('lang.connect.text3') }}</p>
        <h5>{{ $t('lang.connect.objectives') }}</h5>
        <ol>
          <li class="f12 lh6">{{ $t('lang.connect.o1') }}</li>
          <li class="f12 lh6">{{ $t('lang.connect.o2') }}</li>
          <li class="f12 lh6">{{ $t('lang.connect.o3') }}</li>
        </ol>
      </div>
    </div>
    <div class="become reward-system">
      <div class="con">
        <h5>{{ $t('lang.connect.system') }}</h5>
        <div class="system">
          <div
            class="list"
            :class="index == 0?'list-header':''"
            v-for="(item, index) in $t('lang.connect.table')"
            :key="index"
          >
            <span>{{ item.t1 }}</span>
            <span>{{ item.t2 }}</span>
            <span>{{ item.t3 }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="become btmborder">
      <div class="con">
        <h5>{{ $t('lang.connect.tit4') }}</h5>
        <div class="start">
          <p class="f12">{{ $t('lang.connect.text4') }}</p>
          <button class="btn" @click="gotoLink(community.get_start)">{{ $t('lang.connect.btn') }}</button>
        </div>
      </div>
    </div>
    <div class="partners btmborder">
      <div class="con">
        <h3>{{ $t('lang.connect.partners') }}</h3>
        <div class="list">
          <div class="item" v-for="(item, index) in partners" :key="index">
            <img :src="item.img" @click="gotoLink(item.url)" />
          </div>
        </div>
      </div>
    </div>
    <div class="partners btmborder">
      <div class="con" id="exchanges">
        <h3>{{ $t('lang.connect.exchanges') }}</h3>
        <div class="list">
          <div class="item" v-for="(item, index) in exchanges" :key="index">
            <img :src="item.img" @click="gotoLink(item.url)" />
          </div>
        </div>
      </div>
    </div>
    <div class="partners">
      <div class="con">
        <h3>{{ $t('lang.connect.backers') }}</h3>
        <div class="list">
          <div class="item" v-for="(item, index) in backers" :key="index">
            <img :src="item.img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {
  home,
  community,
  community_latest_blogs,
  community_media_partner,
  community_exchanges,
} from "../../common/link.js";
export default {
  name: "Connect",
  data() {
    return {
      partners: [],
      exchanges: [],
      backers: [],
      swiperOption: {
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
        slidesPerView: 4,
        spaceBetween: 15,
      },
      swiperData: [],
      icons: [
        { icon: "facebook", link: home.social_facebook },
        { icon: "ins", link: home.social_twitter },
        { icon: "tel", link: home.social_telegram },
        { icon: "action", link: home.social_youtube },
      ],
      community,
    };
  },
  components: {
    Header,
  },
  created() {
    let swiperData = [];
    for (var i = 1; i <= 12; i++) {
      swiperData.push({
        img: require("../../assets/images/b" + i + ".png"),
        url: community_latest_blogs[i],
      });
    }
    this.swiperData = swiperData;

    let partnersName = [
      "yahoo",
      "bitcoin",
      "businessinsider",
      "blockmanity",
      "coinspeaker",
      "thebitcoinnews",
      "hackernoon",
      "bitcoinprbuzz",
      "themerkle",
      "coinidol",
    ];
    let partners = [];
    for (var i = 1; i <= 10; i++) {
      partners.push({
        img: require("../../assets/images/ico" + i + ".png"),
        url: community_media_partner[partnersName[i - 1]],
      });
    }
    this.partners = partners;

    let exchangesName = [
      "zb",
      "okex",
      "rightbtc",
      "bittrex",
      "mxc",
      "biki",
      "bitz",
      "hotbit",
      "bw",
      "bibox",
      "coinsuper",
    ];
    let exchanges = [];
    for (var i = 1; i <= 11; i++) {
      exchanges.push({
        img: require("../../assets/images/bb" + i + ".png"),
        url: community_exchanges[exchangesName[i - 1]],
      });
    }
    this.exchanges = exchanges;

    let backers = [];
    for (var i = 1; i <= 3; i++) {
      backers.push({ img: require("../../assets/images/cc" + i + ".png") });
    }
    this.backers = backers;
    localStorage.setItem("url", "connect");
  },
  mounted() {
    window.scrollTo(0, 0);
    if (
      this.$route.params.id == "ambassador" ||
      this.$route.params.id == "exchanges"
    ) {
      this.handleScroll(this.$route.params.id);
    }
  },
  methods: {
    enter() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    leave() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(url, "_blank");
    },
    handleScroll(id) {
      if (id) {
        let offsetTop = document.querySelector("#" + id).offsetTop;
        window.scrollTo(0, offsetTop - 60);
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

image(url) {
  background: url('../../assets/images/' + url + '.png') center center no-repeat;
  background-size: 100% auto;
}

.connect {
  padding-top: 0.96rem;

  .btmborder {
    border-bottom: 2px solid #f1f1f1;
  }

  h3 {
    title();
    margin-bottom: 0.3rem;
  }

  p {
    text();
    margin-bottom: 0.3rem;

    &.mbtm52 {
      margin-bottom: 0.52rem;
    }
  }

  h5 {
    subtitle();
    margin-bottom: 0.3rem;

    &:after {
      content: '';
      display: block;
      width: 0.34rem;
      height: 1px;
      background-color: $dark;
    }
  }

  .icons {
    center();
    justify-content: center;
    margin-bottom: 0.6rem;

    div {
      width: 0.75rem;
      height: 0.75rem;
      margin: 0 0.5rem;
      cursor: pointer;

      &.facebook {
        image('facebook');
      }

      &.ins {
        image('f');
      }

      &.tel {
        image('tele');
      }

      &.action {
        width: 1.04rem;
        image('action');
      }
    }
  }

  .become {
    background-color: $white;

    &.reward-system {
      background-color: #f1f1f1;
    }

    ol {
      list-style: disc;
      text();
      margin-bottom: 0.3rem;

      .lh6 {
        line-height: 0.6rem;
      }
    }
  }

  .system {
    background-color: $white;
    margin-bottom: 0.6rem;
    box-shadow: 0 3px 8px rgba(10, 10, 10, 0.1);

    .list {
      height: 0.68rem;
      line-height: 0.68rem;
      center();
      border-bottom: 1px solid #e5e5e5;

      &.list-header {
        height: 0.86rem;
        line-height: 0.86rem;
        background-color: rgba(247, 147, 26, 0.08);
        border-bottom: none;
      }

      &:last-child {
        border-bottom: none;
      }

      span {
        flex: 2;
        text-align: center;
        border-left: 1px solid #e5e5e5;
        font-size: 0.18rem;
        color: #919191;
        ellipsis();

        &:first-child {
          flex: 1;
          border-left: none;
        }
      }
    }
  }

  .start {
    position: relative;
    background-color: $white;
    min-height: 2.6rem;
    padding: 0.6rem 5rem 0.6rem 0.6rem;
    box-shadow: 0 3px 8px rgba(10, 10, 10, 0.1);

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0.6rem;
      display: block;
      width: 3.67rem;
      height: 2.26rem;
      margin-top: -1.13rem;
      image('jl');
      background-size: auto 100%;
    }

    .btn {
      width: 2.9rem;
    }
  }

  .partners {
    background-color: #fff;

    .list {
      center();
      flex-wrap: wrap;
      padding: 0.3rem;
      padding-bottom: 0;
      background-color: $white;
    }

    .item {
      margin-bottom: 0.35rem;
      width: 33.3%;
      text-align: center;
      cursor: pointer;

      img {
        width: auto;
        max-width: 100%;
      }
    }
  }

  .swiper {
    position: relative;

    .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
      color: #d7d7d7;
      left: -5%;
    }

    .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
      color: #d7d7d7;
      right: -5%;
    }
  }

  .swiper-img {
    width: 3rem;
    height: 1.63rem;
    cursor: pointer;

    img {
      width: auto;
      max-width: 100%;
    }
  }
}

@media screen and (max-width: 720px) {
  .connect {
    h5 {
      font-size: 0.4rem;
    }

    padding-top: 40px;

    .swiper {
      .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
        right: -10%;
      }

      .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
        left: -10%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/community/Connect.vue